import { Box, Button, Container } from "@mui/material";
import { Constant, QuoteStatus, UserRole } from "../../QuoteRequest/Content";
import CustomButton from "../Button/Button";
import { FooterButtonWrapper } from "./FooterButtonStyled";
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import { green } from '@mui/material/colors';
import { indigo } from '@mui/material/colors';

const FooterButtons = ({ leftButton, onGoback, rightButtonTextOne, leftButtonTextTwo, onSubmitButton, onRightButtonClick, onRejectButton, quoteStatus, requestType, userRole, pricingTeamApproveRejectDiscount,showButtons, loading, draftLoading }) => {
 
    return (
        <FooterButtonWrapper>
            <Container maxWidth="xl">
                <Box className="d-flex">
                    <Box className="rightButton">
                        <Button variant="contained"   sx={{
                                            fontFamily: '"Noto Sans", sans-serif', 
                                        }}onClick={onGoback}>{leftButton}</Button>
                    </Box>
                    {showButtons && <Box className="leftButtons">
                        {quoteStatus === QuoteStatus.SAVEASDRAFT &&
                            <div className="leftBtnOne">                                
                                <Box sx={{ m: 1, position: 'relative' }}>
                                    <Button
                                      sx={{
                                        fontFamily: '"Noto Sans", sans-serif', 
                                    }}
                                        variant="outlined"
                                        className="btnleftone"
                                        disabled={draftLoading}
                                        onClick={onRightButtonClick}>
                                        {draftLoading ? 'Saving details..' : rightButtonTextOne}                                        
                                    </Button>
                                   
                                    {draftLoading && (
                                        <CircularProgress
                                            size={24}
                                            sx={{
                                                color: indigo[500],
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                marginTop: '-12px',
                                                marginLeft: '-12px',
                                            }}
                                        />
                                    )}
                                </Box>

                            </div>
                        }
                            
                        {(quoteStatus === QuoteStatus.SAVEASDRAFT
                          || ((quoteStatus === QuoteStatus.QUOTEPENDINGSAMLEADERSHIP && (userRole === UserRole.SAMLEADERSHIPTEAM || userRole === UserRole.SAMLEADERSHIPTEAMLEVEL3))
                          ||(quoteStatus === QuoteStatus.QUOTEPENDINGPRICINGMANAGERANDSAMLEADERSHIP && (userRole === UserRole.PRICINGMANAGER || userRole === UserRole.SAMLEADERSHIPTEAM || userRole === UserRole.SAMLEADERSHIPTEAMLEVEL3))
                          ||(quoteStatus === QuoteStatus.QUOTEPENDINGPRICINGVPANDSAMLEADERSHIP && (userRole === UserRole.PRICINGVP || userRole === UserRole.SAMLEADERSHIPTEAM || userRole === UserRole.SAMLEADERSHIPTEAMLEVEL3))
                          || quoteStatus === QuoteStatus.QUOTEPENDINGPRICINGMANAGER && userRole === UserRole.PRICINGMANAGER
                          || quoteStatus === QuoteStatus.QUOTEPENDINGPRICINGVP && userRole === UserRole.PRICINGVP
                                || quoteStatus === QuoteStatus.QUOTEPENDINGPRICINGTEAM && userRole === UserRole.PRICINGTEAM
                                || quoteStatus === QuoteStatus.QUOTEPENDINGINITIALREQUESTOR && (userRole === UserRole.SAMTEAM || userRole === UserRole.PRICINGTEAM || userRole === UserRole.SAMLEADERSHIPTEAM || userRole === UserRole.SAMLEADERSHIPTEAMLEVEL3))) &&
                            <div className="leftBtnTwo">                                

                                <Box sx={{ m: 1, position: 'relative' }}>
                                    <CustomButton
                                      sx={{
                                        fontFamily: '"Noto Sans", sans-serif', 
                                    }}
                                        buttonName={loading ? 'Submitting..' : leftButtonTextTwo}
                                        onClick={onSubmitButton}
                                        disabled={loading}
                                        color="success"
                                    >

                                    </CustomButton>
                                    {loading && (
                                        <CircularProgress
                                            size={24}
                                            sx={{
                                                color: green[50],
                                                position: 'absolute',
                                                top: '50%',
                                                left: '50%',
                                                marginTop: '-12px',
                                                marginLeft: '-12px',
                                            }}
                                        />
                                    )}
                                </Box>

                            </div>
                        }                                                
                    </Box>}
                </Box>
            </Container>
        </FooterButtonWrapper>
    );
};

export default FooterButtons;